import axios from 'axios';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || '';

// Same bug class as the customer-document preview (see
// customerMaster/customerDocumentHelpers.js): a saved image's fullUrl comes
// straight from the shared FileUpload/GetFile API and is used as-is in a
// plain <img src>. That request carries none of this app's auth headers
// (those only get attached by the axios interceptor), so anything but a
// fully public file 401s silently and the <img> just renders broken/blank.
// Some already-uploaded rows can also carry a fullUrl baked against whatever
// host the backend happened to be running on at upload time (e.g. a
// developer's own local instance) instead of the real API host.
const LOCALHOST_ORIGIN_PATTERN = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i;

export const rewriteLocalhostImageUrl = (url) => {
  if (!url || !IMAGE_URL || !LOCALHOST_ORIGIN_PATTERN.test(url)) return url;
  try {
    const targetOrigin = new URL(IMAGE_URL).origin;
    return url.replace(LOCALHOST_ORIGIN_PATTERN, targetOrigin);
  } catch {
    return url;
  }
};

// The preview panel used a plain <img> for every attachment, which silently
// renders blank for anything a browser can't decode as an image (a PDF,
// most obviously) even once the blob itself was fetched correctly. Detect
// image vs. non-image so the caller can pick <img> vs. <iframe>, the same
// split used for customer documents (see isCustomerDocumentImage).
export const isUnitImageFile = (row, url = '') => {
  if (row?.file instanceof File) {
    return row.file.type.startsWith('image/');
  }
  return /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(url || row?.fileName || row?.originalFileName || '');
};

export const fetchAuthenticatedImageBlob = async (url) => {
  const token = localStorage.getItem('Token');
  const db = localStorage.getItem('DataBase');
  const response = await axios.get(url, {
    responseType: 'blob',
    headers: {
      apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
      Authorization: `Bearer ${token}`,
      db,
    },
  });
  return response.data;
};
